import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function WandIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_11329_31315" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_11329_31315)"><path d="M4.55375 20.5L3.5 19.4462L11.1308 11.8L6.75975 10.723L11.325 7.8885L10.929 2.5L15.048 5.977L20.025 3.95L18.023 8.94225L21.5 13.046L16.1115 12.675L13.2615 17.2402L12.175 12.8693L4.55375 20.5ZM5.14425 7.40375L3.5 5.7595L5.14425 4.1155L6.7885 5.7595L5.14425 7.40375ZM13.875 13.4348L15.3057 11.1038L18.0443 11.3077L16.275 9.20575L17.304 6.671L14.7693 7.7L12.6673 5.946L12.8712 8.66925L10.55 10.1155L13.2038 10.7712L13.875 13.4348ZM18.2405 20.5L16.5962 18.8557L18.2405 17.2115L19.8845 18.8557L18.2405 20.5Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}